import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction<{ plainPassword: string }>('auth/UPDATE_PASSWORD'));
